import React from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import './App.css'
import WebsiteRoutes from './routes/WebsiteRoutes'
import AppRoutes from './routes/AppRoutes'
import { Provider } from 'react-redux'
import { store, persistor } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import history from './routes/history'
import { PrefetchGate } from './components/PrefetchGate/PrefetchGate'
import ScrollToTop from './routes/ScrollToTop'

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <PrefetchGate>
                    <Router history={history}>
                        <ScrollToTop />
                        <WebsiteRoutes />
                        <Switch>
                            <Route path={'/app'} component={AppRoutes} />
                        </Switch>
                    </Router>
                </PrefetchGate>
            </PersistGate>
        </Provider>
    )
}

export default App
